/**
 * @description Get the web content URL
 * @param contentId The ID of the content
 * @returns The URL string
 */
export const getWebContentUrl = (contentId: string): string => {
  return `api/web/content/${contentId}`;
}

export const getApiUrlForParams = (url: string, params: { [key: string]: string | number }): string => {
  return url.replace(/{([^{}]*)}/g, (_, key) => {
    return params[key]?.toString() || '';
  });
}

export const toQueryString = (params: Record<string, any>): string => {
  return Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(([key, value]) =>
      `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join('&');
}

export const CHECK_EMAIL = 'api/public/account/find';
export const CREATE_ACCOUNT = 'api/public/account';
export const FIND_PLAN_API_URL = 'api/public/contracts';
export const UNLINK_PLAN_API_URL = '/api/{auth0Id}/contracts/{contractNumber}/profile'
export const LINK_PLAN_API_URL = '/api/{auth0Id}/contracts/profile'
export const CONTACT_SUBMISSION_API = 'api/public/contact';
export const CANCEL_REASON_URL = 'api/public/enums/cancelreasons';
export const GET_OFFERS_URL = 'api/public/contracts/offers';
export const CHECK_OFFER_ACCEPTED_URL = 'api/public/contracts/offers';
export const CANCEL_CONTRACT_URL = '/api/{auth0Id}/contracts/{contractNumber}/contract/cancel';
export const OFFER_STATUS_URL = 'api/public/contracts/offers';
export const SAVE_BILLING_INFO = '/api/public/contracts/{contractNumber}/payments/info';
export const CANCEL_PLAN_PAYMENT_API = '/api/{auth0Id}/contracts/payment-collection';
export const PAST_DUE_PAYMENT_API = 'api/public/contracts/{contractNumber}/payments';
export const PREFERENCES_GET_CONSENT_URL = 'api/public/user/consent';
export const GET_COVERED_TRADES = 'api/{auth0Id}/contracts/{contractNumber}/coveredtrades/{productId}';
export const GET_CATEGORY_ITEMS = "api/public/enums/categories";
export const PLAN_STORY_URL = 'api/contracts/planStory';
export const GET_COVERED_ITEMS = 'api/{auth0Id}/contracts/{contractNumber}/covereditems/{productId}';
export const GET_ITEMS_LOCATIONS = 'api/public/enums/itemsandlocations/{categoryId}';
export const SAVE_CONTACT_INFO_FOR_PROFILE = '/api/public/contracts/{contractNumber}/contact';
export const VIVR_SERVICEJOBS_LIST = 'api/{subStr}/contracts/{contractNumber}/service/jobs';
export const GET_CONTRACTS = 'api/{subStr}/contracts/{contractNumber}/dashboard';
export const VIVR_SERVICEJOBID_DETAILS = 'api/public/service/jobs/{serviceOrderId}';
export const VIVR_SERVICEJOBID_DETAILS_CANCEL = 'api/public/service/jobs/cancel/{jobNumber}'
export const PM_ITEMS = 'api/public/contracts/{contractNumber}/preventive-maintenance-items';
export const GET_SYMPTOMS_FOR_SELECTED_ITEM = 'api/decision/symptoms?itemId={selectedItem}';
export const GET_BRANDS = 'api/public/enums/brands';
export const VALIDATE_AUTOMATIC_DECISION = 'api/decision/credit';
export const SAVE_CLAIM_INFO = 'api/public/contracts/{contractNo}/coverage/{itemId}';
export const DEDUCTIBLE_AMOUNT = 'api/{auth0Id}/contracts/{contractNo}/deductible';
export const CHECK_AVAILABILITY = 'api/public/contracts/{contractNo}/service/provider/availability/multi';
export const GET_SEARS_ACCOUNT_NUMBERS = 'api/public/enums/preferred';
export const SUBMIT_CLAIM = 'api/public/claims/multi';
export const CUSTOMER_OPTION = '/api/public/service/jobs/customeroption/accept';
export const GET_JOBS_BY_MODEL = '/api/contracts/{contractNo}/service/jobsbymodel?';
export const GET_RECALL_AVAILABILITY = '/api/public/contracts/{contractNo}/service/provider/availability/recall?'
export const CONFIRM_RECALL = '/api/public/claims/recall'
export const CLAIM_REIMBURSEMENT = '/api/{auth0Id}/contracts/{contractNumber}/claim-credit/{serviceJobId}/payment-option';
export const REPLACEMENT_DEDUCTIBLE_PAYMENT = '/api/{auth0Id}/contracts/{contractNumber}/paymentcollectionassociate';
export const ACCEPT_REPLACE_BUYOUT_CLAIM = '/api/{auth0Id}/contracts/{contractNumber}/claim/service/jobs/exception/{serviceOrderId}';
export const GET_ITEMS = 'api/public/enums/items';
export const GET_LOCATIONS = 'api/public/enums/locations';
export const PARSE_APPLIANCE_TAG = 'api/products/images/extraction';
export const CHECK_ASSOCIATED_CONTRACTS_API = 'api/contracts/{contractNumber}/hasAssociatedContracts';
export const ENROLLMENT = 'api/contracts/crosssell/enrollment';
export const BASE_COVERAGE = 'api/products/baseCoverage';
